import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { IntelListComponent } from './intel-list.component';
import { CreateIntelListComponent } from './create-intel-list/create-intel-list.component';
import { ImportIntelListComponent } from './create-intel-list/import-intel-list/import-intel-list.component';
import { ViewIntelListComponent } from './view-intel-list/view-intel-list.component';

const routes: Routes = [
  { path: '', component: IntelListComponent},
  { path: 'create-intel-list', component: CreateIntelListComponent},
  { path: 'import-intel-list', component: ImportIntelListComponent}, 
  { path: 'view-intel-list', component: ViewIntelListComponent}
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class IntelListRoutingModule { }
